import * as yup from 'yup';

type TTranslate = (key: string) => string;

// A phone value like "+421" (just the selected country's dial code, no digits typed) is a
// non-empty string, so plain .required() lets it through — this catches that case specifically.
const hasEnoughDigits = (value: string | undefined) => (value || '').replace(/\D/g, '').length >= 6;

const phoneNumberSchema = (t: TTranslate) =>
  yup
    .string()
    .required(t('Web.Error_phone_required'))
    .test('phone-has-digits', t('Web.Error_phone_invalid'), hasEnoughDigits);

export const getSignUpValidationSchema = (t: TTranslate) =>
  yup.object().shape({
    fullName: yup.string().required(t('Web.Error_full_name_required')),
    phoneNumber: phoneNumberSchema(t),
    cityCode: yup.number().required(t('Web.Error_city_required')),
    email: yup.string().email(t('Web.Error_email_invalid')).required(t('Web.Error_email_required')),
    agreedToTerms: yup.boolean().oneOf([true], t('Web.Error_agreement_required')).required(),
  });

export const getPhoneNumberValidationSchema = (t: TTranslate) =>
  yup.object({
    phoneNumber: phoneNumberSchema(t),
  });
